const transferNotice = () => import ('@/pages/message/transferNotice/index.vue')
export default [
    {
        path: 'notice/transferNotice',
        name:'notice/transferNotice',
        component: transferNotice
    },

]



// WEBPACK FOOTER //
// ./src/router/message.js